import { createRequest, RequestConfig } from 'app/common/api';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/add_report_template',
};

type NewReportTemplate = {
  name: string;
  file: any;
};

export const addReportTemplateRequest = (data: NewReportTemplate) => {
  const body = new FormData();
  const props = new Blob([JSON.stringify({ name: data.name })], {
    type: 'application/json',
  });

  body.append('reportTemplate', props);
  body.append('reportTemplateFile', data.file);

  return createRequest({
    url: config.url,
    method: config.method,
    body,
    headers: {
      // set required headers (multipart/form-data with boundary) automatically by broweser
    },
  });
};
